import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { ArbitroPareja, ArbitroParejaJSON } from './ArbitroPareja';

export interface ArbitroParejaHistorialPartidos {
  cantidad: number;
  cat_nombre: string;
  div_nombre: string;
  tor_rama: string;
  tem_descripcion: string;
}

export interface HistorialPareja {
  arbitro1: string;
  arbitro2: string;
  inicio: string;
  fin: string;
  activo: boolean;
  cantidadPartidosDirigidos: number;
}

export class ArbitroParejaSystem {
  private readonly base = '/arbitroparejas';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getArbitroParejaIdentifiedBy(id: string): Promise<ArbitroPareja> {
    const data = await this.requestHandler.get<ArbitroParejaJSON>(`${this.base}/${id}`);
    return ArbitroPareja.fromJSON(data);
  }

  async getList(): Promise<ArbitroPareja[]> {
    const data = await this.requestHandler.get<ArbitroParejaJSON[]>(`${this.base}`);
    return data.map((entity) => ArbitroPareja.fromJSON(entity));
  }

  async getListForDropdown(): Promise<ArbitroPareja[]> {
    const data = await this.requestHandler.get<ArbitroParejaJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => ArbitroPareja.fromJSON(entity));
  }

  async getPairs(arbId: string, apId: string): Promise<ArbitroPareja[]> {
    const queryParam = apId === 'new' ? '' : `?apId=${apId}`;
    const data = await this.requestHandler.get<ArbitroParejaJSON[]>(
      `${this.base}/get-pairs/${arbId}${queryParam}`
    );
    return data.map((entity) => ArbitroPareja.fromJSON(entity));
  }

  async getHistoryPairs(arbId: string): Promise<HistorialPareja[]> {
    const data = await this.requestHandler.get<HistorialPareja[]>(`${this.base}/get-history-pairs/${arbId}`);
    return data;
  }

  async getHistorialPartidos(apId: string): Promise<ArbitroParejaHistorialPartidos[]> {
    const data = await this.requestHandler.get<ArbitroParejaHistorialPartidos[]>(
      `${this.base}/get-historial-partidos/${apId}`
    );
    return data;
  }

  async getListForAutocomplete(searchKey: string): Promise<ArbitroPareja[]> {
    const data = await this.requestHandler.get<ArbitroParejaJSON[]>(
      `${this.base}/for-autocomplete?searchKey=${searchKey}`
    );
    return data.map((entity) => ArbitroPareja.fromJSON(entity));
  }

  async save(entity: ArbitroPareja) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<ArbitroParejaJSON, ArbitroParejaJSON>(this.base, data);
    return ArbitroPareja.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
